<template>
    <div>
        <el-dialog width="50%" @close="close" :visible="dialogFormVisible" title="找回密码">
            <el-form :rules="rules" ref="form" label-position="left" :model="form" label-width="160px">
                <el-form-item label="有效证件号码" prop="yxzjhm">
                    <el-input v-model="form.yxzjhm" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="sjhm">
                    <el-input v-model="form.sjhm" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="password">
                    <el-input type="password" v-model="form.password" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="再次输入新密码" prop="repeatPassword" required>
                    <el-input type="password" v-model="form.repeatPassword" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="sjyzm">
                    <el-input v-model="form.sjyzm" autocomplete="off">
                        <template slot="append">
                            <div style="cursor: pointer" @click="sendVerification">{{ verificationLabel }}</div>
                        </template>
                    </el-input>
                </el-form-item>
            </el-form>
            <template slot="footer"><el-button type="primary" @click="submit">提交</el-button> </template>
        </el-dialog>
    </div>
</template>

<script>
import request from "@/api/loginAndRegister";
import md5 from "js-md5";
export default {
    name: "TalentRecruitPersonalFindPassword",

    data() {
        return {
            dialogFormVisible: false,
            form: {
                yxzjhm: "",
                sjhm: "",
                password: "",
                repeatPassword: "",
                sjyzm: "",
            },
            rules: {
                yxzjhm: [{ required: true, message: "请输入有效证件号码", trigger: "blur" }],
                sjhm: [
                    { required: true, message: "请输入手机号", trigger: "blur" },
                    { pattern: /^1[0-9]{10}$/, message: "手机号不正确", trigger: "blur" },
                ],
                password: [{ required: true, message: "请输入密码", trigger: "blur" }],
                repeatPassword: [
                    {
                        validator: (rule, value, callback) => {
                            if (value === "") {
                                callback(new Error("请再次输入密码"));
                            } else if (value !== this.form.password) {
                                callback(new Error("两次输入密码不一致!"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "blur",
                    },
                ],
                sjyzm: [{ required: true, message: "请输入验证码", trigger: "blur" }],
            },
            countdown: false,
            verificationLabel: "发送验证码",
        };
    },

    watch: {
        findPasswordVisible() {
            this.dialogFormVisible = this.findPasswordVisible;
        },
    },
    computed: {
        findPasswordVisible() {
            return this.$store.state.findPasswordVisible;
        },
    },
    mounted() {},

    methods: {
        async submit() {
            this.$refs.form.validate(async (valid) => {
                const para = {
                    yxzjhm: this.form.yxzjhm,
                    sjhm: this.form.sjhm,
                    password: md5(this.form.password),
                    sjyzm: this.form.sjyzm,
                };
                if (valid) {
                    try {
                        const res = await request.findPwd(para);
                        console.log("findPwd res", res);
                        this.$store.commit("closeFindPassword");
                        this.$store.commit("openLogin");
                    } catch (error) {
                        console.log("findPwd error", error);
                    }
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        async sendVerification() {
            if (this.countdown) {
                return;
            }
            this.$refs.form.validateField("sjhm", async (errorMessage) => {
                if (errorMessage) {
                    return;
                }
                try {
                    const res = await request.sendYzm({
                        phone: this.form.sjhm,
                    });
                    console.log("sendYzm res", res);
                    let countdownTime = 60;
                    const id = setInterval(() => {
                        if (countdownTime === 0) {
                            clearInterval(id);
                            this.verificationLabel = "发送验证码";
                            this.countdown = false;
                        } else {
                            countdownTime--;
                            this.verificationLabel = `${countdownTime}秒后可再次发送`;
                        }
                    }, 1000);
                    this.countdown = true;
                } catch (error) {
                    console.log("sendYzm error", error);
                }
            });
        },
        close() {
            this.$store.commit("closeFindPassword");
            this.$refs.form.resetFields();
        },
    },
};
</script>

<style lang="scss" scoped></style>
